import {cdnImage} from '@/util/cdnImage';
import React, {memo} from 'react';
import MUIContainer from '@/components/MUI-Components/MUI-Container';
import dynamic from 'next/dynamic';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Rating from '@/components/Common/Rating';
import Typography from '@mui/material/Typography';
const DisplayImage = dynamic(import('@/components/Ui-components/display-image'));
import Link from 'next/link';
import Clutch from 'public/images/company/clutch.webp';
import Goodfirms from 'public/images/company/goodfirms.webp';
import Cioreview from 'public/images/banner/top_developers.webp';
import {spacing} from '@/styles/tokens';
const selectFirm = cdnImage('Latest-home-page/SelectedFirms.webp');

const companyImageGridSx = {
    backgroundColor: 'rgba(36, 68, 134, 0.042712)',
    height: '330px',
    width: '100%',
    display: 'flex',
    justifyContent: 'left',
    padding: '45px',
    textAlign: 'center',
    '@media (max-width:1024px)': {height: '250px !important'},
    '@media (max-width:430px)': {
        height: '425px !important',
        marginTop: '30px !important'
    }
} as const;

const companyHeadingSx = {
    textAlign: 'left !important',
    fontFamily: "'Headers', sans-serif !important",
    fontSize: '60px !important',
    fontWeight: '700 !important',
    '@media (max-width:430px)': {textAlign: 'center !important'}
} as const;

const companySubHeadingSx = {
    fontFamily: "'RegularText', sans-serif !important",
    fontSize: '21px !important',
    '@media (max-width:430px)': {textAlign: 'center !important'}
} as const;

const companyLogoAppfuturaStyle = {width: '185px'} as const;

const companyLogoGoodfirmsBoxSx = {
    '@media (max-width:430px)': {'& img': {marginTop: spacing[20]}}
} as const;

const companyRatingSx = {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'left',
    padding: '5px 0',
    gap: '5px'
} as const;

const Company = () => {
    return (
        <Grid item xs={12}>
            <Box>
                <MUIContainer>
                    <Box>
                        <Grid container alignItems="center">
                            <Grid item xs={12} sm={12} md={6}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <Grid container>
                                            <Grid item xs={12} sm={6} md={5}>
                                                <Typography sx={companyHeadingSx}>500+</Typography>
                                                <Typography sx={companySubHeadingSx}>
                                                    Custom Solutions <br /> Delivered
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={6}>
                                                <Typography sx={companyHeadingSx}>200+</Typography>
                                                <Typography sx={companySubHeadingSx}>
                                                    Seasoned Technology Experts & Business Consultants
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container>
                                            <Grid item xs={12} sm={6} md={5}>
                                                <Typography sx={companyHeadingSx}>10+</Typography>
                                                <Typography sx={companySubHeadingSx}>
                                                    Ready to deploy <br /> software
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={5}>
                                                <Typography sx={companyHeadingSx}>20+</Typography>
                                                <Typography sx={companySubHeadingSx}>Years of Software Development Expertise</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} sm={12} md={6} sx={companyImageGridSx}>
                                <Grid container spacing={3} justifyContent="space-between">
                                    <Grid item xs={12}>
                                        <Grid container justifyContent="space-between" textAlign="left">
                                            <Grid item xs={12} sm={6} md={6}>
                                                <Link
                                                    href="https://clutch.co/profile/debut-infotech#reviews"
                                                    className="menu-links"
                                                    target="_blank"
                                                >
                                                    <DisplayImage src={Clutch} alt="clutch" />
                                                    <Box sx={companyRatingSx}>
                                                        <span> 4.8</span>
                                                        <Rating value={4.5} />
                                                    </Box>
                                                </Link>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={6}>
                                                <Link
                                                    href="https://www.goodfirms.co/company/debut-infotech"
                                                    className="menu-links"
                                                    target="_blank"
                                                >
                                                    <Box sx={companyLogoGoodfirmsBoxSx}>
                                                        <DisplayImage src={Goodfirms} alt="goodfirms" />
                                                    </Box>
                                                    <Box sx={companyRatingSx}>
                                                        4.8
                                                        <Rating value={4.5} />
                                                    </Box>
                                                </Link>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container justifyContent="space-between" alignItems="center" textAlign="left" spacing={3}>
                                            <Grid item xs={12} sm={6} md={6}>
                                                <Link
                                                    href="https://selectedfirms.co/agency/debut-infotech-pvt-ltd"
                                                    className="menu-links"
                                                    target="_blank"
                                                >
                                                    <DisplayImage src={selectFirm} alt="selectFirm" style={companyLogoAppfuturaStyle} />
                                                    <Box sx={companyRatingSx}>
                                                        5
                                                        <Rating value={5} />
                                                    </Box>
                                                </Link>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={6}>
                                                <Link
                                                    href="https://www.topdevelopers.co/profile/debut-infotech"
                                                    className="menu-links"
                                                    target="_blank"
                                                >
                                                    <DisplayImage src={Cioreview} alt="topdevelopers" />
                                                    <Box sx={companyRatingSx}>
                                                        4.7
                                                        <Rating value={4.5} />
                                                    </Box>
                                                </Link>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </MUIContainer>
            </Box>
        </Grid>
    );
};

export default memo(Company);
